(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.section = this.dataset.section;
      this.openSources = ['product', 'bundle', 'complete-the-look', 'featured-product'];

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-discount-collapse]')) {
          e.preventDefault();
          this.classList.add('is-discount-collapsed');
          return;
        }
        if (e.target.closest('[data-discount-expand]')) {
          e.preventDefault();
          this.classList.remove('is-discount-collapsed');
          return;
        }
        if (e.target.closest('[data-cd-close]')) {
          e.preventDefault();
          this.close();
          return;
        }
        var changeBtn = e.target.closest('[data-change]');
        if (changeBtn) {
          var item = changeBtn.closest('.mt-cdrawer__item');
          if (item) this.change(item.dataset.key, parseInt(changeBtn.dataset.change, 10));
        }
      });

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) {
          var row = e.target.closest('.mt-cdrawer__item');
          if (row) this.change(row.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });

      document.addEventListener('cart:updated', (e) => {
        this.refresh();
        if (e.detail && this.openSources.indexOf(e.detail.source) !== -1) this.open();
      });

      document.addEventListener('click', (e) => {
        var link = e.target.closest('a[href$="/cart"]');
        if (link && !link.hasAttribute('data-no-drawer') && !e.metaKey && !e.ctrlKey) {
          e.preventDefault();
          this.refresh().then(() => this.open());
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      });
    }

    open() {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      if (window.MetryScrollLock) window.MetryScrollLock.lock();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      if (window.MetryScrollLock) window.MetryScrollLock.unlock();
    }

    async change(id, quantity) {
      this.classList.add('is-loading');
      try {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity })
        });
        await this.refresh();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'drawer' } }));
      } catch (e) {
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async refresh() {
      try {
        var html = await (await fetch('/?section_id=' + this.section)).text();
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
        if (fresh) this.innerHTML = fresh.innerHTML;
      } catch (e) {
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('country-select')) {
    customElements.define('country-select', class extends HTMLElement {
      connectedCallback() {
        const s = this.querySelector('select');
        if (s) s.addEventListener('change', () => s.form && s.form.submit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CartCount extends HTMLElement {
    connectedCallback() { this._on = () => this.refresh(); document.addEventListener('cart:updated', this._on); }
    disconnectedCallback() { document.removeEventListener('cart:updated', this._on); }
    async refresh() { try { const c = await (await fetch('/cart.js')).json(); this.textContent = c.item_count; } catch (e) {} }
  }
  if (!customElements.get('cart-count')) customElements.define('cart-count', CartCount);

  (function () {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const burger = header.querySelector('[data-burger]');
    const drawer = document.querySelector('[data-drawer]');
    const overlay = document.querySelector('[data-overlay]');
    const closeBtn = drawer && drawer.querySelector('[data-drawer-close]');
    const toggle = (open) => {
      const willOpen = open ?? drawer.hasAttribute('hidden');
      [drawer, overlay].forEach(el => { if (!el) return; if (willOpen) { el.removeAttribute('hidden'); requestAnimationFrame(() => el.classList.add('is-open')); } else { el.classList.remove('is-open'); setTimeout(() => el.setAttribute('hidden', ''), 300); } });
      burger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (willOpen) { window.MetryScrollLock.lock(); } else { window.MetryScrollLock.unlock(); }
    };
    if (burger && drawer) {
      burger.addEventListener('click', () => toggle());
      if (closeBtn) closeBtn.addEventListener('click', () => toggle(false));
      if (overlay) overlay.addEventListener('click', () => toggle(false));
      drawer.addEventListener('click', e => { if (e.target.tagName === 'A') toggle(false); });
      addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) toggle(false); });
    }
    // transparent-on-home → solid on scroll
    if (header.classList.contains('header--home')) {
      const onScroll = () => header.classList.toggle('is-scrolled', scrollY > 40);
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    // promo rotator — paused while the tab is hidden so it isn't burning timers in the background
    const track = header.querySelector('[data-promo]');
    if (track) {
      const items = track.querySelectorAll('.header__promo-item');
      if (items.length > 1) {
        let i = 0, timer = null;
        const tick = () => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); };
        const startRot = () => { if (!timer) timer = setInterval(tick, 4000); };
        const stopRot = () => { if (timer) { clearInterval(timer); timer = null; } };
        document.addEventListener('visibilitychange', () => { if (document.hidden) { stopRot(); } else { startRot(); } });
        startRot();
      }
    }
    // locale select submit
    const sel = header.querySelector('[data-locale-select]');
    if (sel) sel.addEventListener('change', () => sel.form && sel.form.submit());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  if (!window.MtCompleteTheLookLoader) {
    window.MtCompleteTheLookLoader = class MtCompleteTheLookLoader {
      static init(container) {
        var panel = container.querySelector('[data-mt-ctl-panel]');
        if (!panel) return;

        if (container._ctlInitBound) {
          MtCompleteTheLookLoader.load(panel);
          return;
        }
        container._ctlInitBound = true;

        MtCompleteTheLookLoader.load(panel);

        if (!document._ctlCartListener) {
          document._ctlCartListener = function (e) {
            var source = e && e.detail && e.detail.source;
            if (source !== 'cart' && source !== 'drawer') {
              var cartRoot = document.querySelector('cart-items');
              if (cartRoot && cartRoot.dataset.section) {
                fetch(window.location.pathname + '?section_id=' + cartRoot.dataset.section)
                  .then(function (r) {
                    return r.text();
                  })
                  .then(function (html) {
                    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
                    if (!fresh) return;
                    cartRoot.innerHTML = fresh.innerHTML;
                    MtCompleteTheLookLoader.init(cartRoot);
                  });
                return;
              }
            }
            document.querySelectorAll('[data-mt-ctl-panel]').forEach(function (ctlPanel) {
              MtCompleteTheLookLoader.load(ctlPanel);
            });
          };
          document.addEventListener('cart:updated', document._ctlCartListener);
        }
      }

      static shopifyRoot() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      }

      static async fetchFragment(sectionId, productId, limit, intent) {
        var root = MtCompleteTheLookLoader.shopifyRoot();
        var url =
          root +
          'recommendations/products?section_id=' +
          encodeURIComponent(sectionId) +
          '&product_id=' +
          encodeURIComponent(productId) +
          '&limit=' +
          encodeURIComponent(limit) +
          '&intent=' +
          encodeURIComponent(intent);

        var html = await fetch(url).then(function (r) {
          return r.ok ? r.text() : '';
        });
        if (!html) return '';

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('[data-complete-the-look-content]');
        if (!source || !source.querySelector('.mt-ctl__item')) return '';

        return source.innerHTML;
      }

      static async load(panel) {
        try {
          var root = MtCompleteTheLookLoader.shopifyRoot();
          var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });

          if (!cart.items.length) {
            if (!panel.dataset.referenceProductId) {
              panel.hidden = true;
              return;
            }
          } else {
            panel.hidden = false;
          }

          var target = panel.querySelector('[data-complete-the-look-content]');
          if (!target) return;

          if (panel.dataset.static === 'true' && target.querySelector('.mt-ctl__item')) {
            panel.hidden = false;
            return;
          }

          var showLimit = parseInt(panel.dataset.limit || '4', 10);
          var fetchLimit = Math.min(Math.max(showLimit * 3, 8), 10);
          var preferredIntent = panel.dataset.intent || 'related';
          var intents = [preferredIntent];
          if (preferredIntent !== 'related') intents.push('related');
          if (preferredIntent !== 'complementary') intents.push('complementary');

          var fragment = '';
          var referenceProductId = panel.dataset.referenceProductId;
          for (var i = 0; i < cart.items.length && !fragment; i++) {
            for (var j = 0; j < intents.length && !fragment; j++) {
              fragment = await MtCompleteTheLookLoader.fetchFragment(
                panel.dataset.sectionId,
                cart.items[i].product_id,
                fetchLimit,
                intents[j]
              );
            }
          }

          if (!fragment && referenceProductId) {
            for (var r = 0; r < intents.length && !fragment; r++) {
              fragment = await MtCompleteTheLookLoader.fetchFragment(
                panel.dataset.sectionId,
                referenceProductId,
                fetchLimit,
                intents[r]
              );
            }
          }

          if (fragment) {
            target.innerHTML = fragment;
            var items = target.querySelectorAll('.mt-ctl__item');
            for (var k = items.length - 1; k >= showLimit; k--) {
              items[k].remove();
            }
            panel.hidden = !target.querySelector('.mt-ctl__item');
            if (window.MetryReveal) {
              window.MetryReveal.init();
              window.MetryReveal.initImageFade();
            }
          } else if (!target.querySelector('.mt-ctl__item')) {
            target.innerHTML = '';
            panel.hidden = true;
          } else {
            panel.hidden = false;
          }
        } catch (e) {
          panel.hidden = true;
        }
      }
    };
  }

  var MtCompleteTheLookLoader = window.MtCompleteTheLookLoader;

  class CartItems extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.section;
      this.addEventListener('click', (e) => {
        const discountBtn = e.target.closest('[data-cart-discount-apply]');
        if (discountBtn) {
          e.preventDefault();
          this.applyDiscount();
          return;
        }

        const changeBtn = e.target.closest('[data-change]');
        if (changeBtn) {
          const key = changeBtn.closest('.mt-cart__row').dataset.key;
          this.change(key, parseInt(changeBtn.dataset.change, 10));
        }
      });

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-qty-input]')) {
          const key = e.target.closest('.mt-cart__row').dataset.key;
          this.change(key, Math.max(0, parseInt(e.target.value, 10) || 0));
        }
      });

      MtCompleteTheLookLoader.init(this);
    }

    disconnectedCallback() {
      /* cart:updated listener is shared on document; kept for page lifetime */
    }

    applyDiscount() {
      const input = this.querySelector('[data-cart-discount]');
      if (!input || !input.value.trim()) return;

      window.location.href =
        '/discount/' + encodeURIComponent(input.value.trim()) + '?redirect=' + encodeURIComponent(window.location.pathname);
    }

    async change(id, quantity) {
      this.classList.add('mt-cart--loading');

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity })
        });

        const html = await (await fetch(location.pathname + '?section_id=' + this.section)).text();
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
        if (fresh) this.innerHTML = fresh.innerHTML;

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart' } }));
        MtCompleteTheLookLoader.init(this);
      } catch (e) {
        window.location.reload();
      } finally {
        this.classList.remove('mt-cart--loading');
      }
    }
  }

  if (!customElements.get('cart-items')) customElements.define('cart-items', CartItems);

  document.querySelectorAll('cart-items').forEach(function (cartEl) {
    MtCompleteTheLookLoader.init(cartEl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  class FacetForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-auto-submit], input[type=checkbox], input[type=number]')) this.form.submit();
      });
    }
  }
  if (!customElements.get('facet-form')) customElements.define('facet-form', FacetForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-target]'); if (!t) return;
        this.showMedia(t.getAttribute('data-target'));
      });
    }
    showMedia(id) {
      if (!id) return;
      this.querySelectorAll('.pgallery__slide').forEach(s => s.classList.toggle('is-active', s.dataset.mediaId == id));
      this.querySelectorAll('.pgallery__thumb').forEach(b => b.classList.toggle('is-active', b.dataset.target == id));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form');
      this.addEventListener('change', () => this.form && this.form.onVariantChange());
    }
    get selectedValues() { return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(i => i.value); }
  }
  if (!customElements.get('variant-selects')) customElements.define('variant-selects', VariantSelects);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.querySelector('variant-selects');
      this.form = this.closest('form');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.querySelectorAll('[data-qty]').forEach(b => b.addEventListener('click', () => this.stepQty(b.dataset.qty)));
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.querySelectorAll('[data-copy]').forEach(b => b.addEventListener('click', () => this.copyCode(b)));
    }
    copyCode(b) {
      const m = (b.dataset.copy.match(/([A-Z0-9]{4,})/) || [])[1] || b.dataset.copy;
      navigator.clipboard && navigator.clipboard.writeText(m);
      b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
    }
    stepQty(dir) { const q = this.querySelector('.qty__input'); let v = parseInt(q.value, 10) || 1; q.value = dir === 'plus' ? v + 1 : Math.max(1, v - 1); }
    onVariantChange() {
      if (!this.selects) return;
      const vals = this.selects.selectedValues;
      const match = this.variants.find(v => JSON.stringify(v.options) === JSON.stringify(vals));
      // update each option's shown value + close the accordion
      this.querySelectorAll('.voption').forEach((d, i) => {
        const val = d.querySelector('.voption__val'); if (val && vals[i]) val.textContent = vals[i];
        d.open = false;
      });
      const priceEl = document.getElementById('price-' + this.section);
      if (!match) { this.setUnavailable(); return; }
      this.idInput.value = match.id;
      if (match.featured_media_id) { const g = document.querySelector('product-gallery'); if (g) g.showMedia(match.featured_media_id); }
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      const text = this.querySelector('[data-atc-text]');
      if (match.available) { this.btn.disabled = false; text.textContent = this.strings.add; }
      else { this.btn.disabled = true; text.textContent = this.strings.soldout; }
    }
    setUnavailable() { this.btn.disabled = true; this.querySelector('[data-atc-text]').textContent = this.strings.unavailable; }
    async onSubmit(e) {
      e.preventDefault(); this.btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: this.idInput.value, quantity: parseInt(this.querySelector('.qty__input').value, 10) || 1 }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.strings.added, false);
      } catch (err) { this.showStatus(err.message, true); } finally { this.btn.disabled = false; }
    }
    showStatus(msg, isError) { if (!this.status) return; this.status.textContent = msg; this.status.hidden = false; this.status.classList.toggle('is-error', !!isError); }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-about-slider"] && !Shopify.designMode) return;
  try {
    
  function initMtAboutSlider(root) {
    var track = root.querySelector('[data-mt-about-slider-track]');
    var prevBtn = root.querySelector('[data-mt-about-slider-prev]');
    var nextBtn = root.querySelector('[data-mt-about-slider-next]');
    if (!track || !prevBtn || !nextBtn) return;

    if (root.dataset.sliderReady === 'true') return;
    root.dataset.sliderReady = 'true';

    var MOBILE_MQ = window.matchMedia('(max-width: 989px)');
    var originals = Array.prototype.slice.call(
      track.querySelectorAll('[data-mt-about-slider-slide]:not([data-mt-about-slider-clone])')
    );

    if (originals.length === 0) return;

    var slides = originals.slice();
    var realCount = originals.length;
    var currentIndex = 0;
    var isAnimating = false;
    var isNormalizing = false;
    var animationFrame = null;
    var cloneFirstIndex = realCount + 1;
    var ANIMATION_MS = 420;

    function isMobile() {
      return MOBILE_MQ.matches;
    }

    function markClone(node, position) {
      node.setAttribute('data-mt-about-slider-clone', position);
      node.classList.remove('is-active');
      node.removeAttribute('data-shopify-editor-block');
    }

    function removeClones() {
      Array.prototype.slice
        .call(track.querySelectorAll('[data-mt-about-slider-clone]'))
        .forEach(function (node) {
          node.remove();
        });
    }

    function buildDesktopClones() {
      removeClones();

      if (realCount <= 1) return;

      var lastClone = originals[realCount - 1].cloneNode(true);
      markClone(lastClone, 'start');
      track.insertBefore(lastClone, originals[0]);

      var endFirstClone = originals[0].cloneNode(true);
      markClone(endFirstClone, 'end');
      track.appendChild(endFirstClone);

      if (realCount >= 2) {
        var endSecondClone = originals[1].cloneNode(true);
        markClone(endSecondClone, 'end');
        track.appendChild(endSecondClone);
      }
    }

    function refreshSlides() {
      slides = Array.prototype.slice.call(
        track.querySelectorAll('[data-mt-about-slider-slide]:not([data-mt-about-slider-clone])')
      );
      realCount = slides.length;
    }

    function getRealSlideIndex(index) {
      if (realCount <= 1) return 0;

      if (slides.length === realCount) {
        return Math.min(Math.max(index, 0), realCount - 1);
      }

      if (index === 0) return realCount - 1;
      if (index >= realCount + 1) return index - (realCount + 1);
      return index - 1;
    }

    function getDesktopIndex(realIndex) {
      if (realCount <= 1) return 0;
      return realIndex + 1;
    }

    function setupMode() {
      isAnimating = false;
      isNormalizing = false;

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }

      refreshSlides();
      var realSlideIndex = getRealSlideIndex(currentIndex);

      if (isMobile()) {
        removeClones();
        slides = Array.prototype.slice.call(
          track.querySelectorAll('[data-mt-about-slider-slide]:not([data-mt-about-slider-clone])')
        );
        cloneFirstIndex = realCount;
        currentIndex = realSlideIndex;
      } else {
        buildDesktopClones();
        slides = Array.prototype.slice.call(track.querySelectorAll('[data-mt-about-slider-slide]'));
        cloneFirstIndex = realCount + 1;
        currentIndex = getDesktopIndex(realSlideIndex);
      }

      updateActiveSlide();
      updateButtons();
      jumpToIndex(currentIndex);
    }

    function setSnapEnabled(enabled) {
      track.style.scrollSnapType = enabled ? 'x mandatory' : 'none';
    }

    function getTrackPaddingInline() {
      var styles = window.getComputedStyle(track);
      return parseFloat(styles.paddingLeft || '0') || 0;
    }

    function getClosestIndex() {
      var trackCenter = isMobile()
        ? track.scrollLeft + getTrackPaddingInline()
        : track.scrollLeft + track.clientWidth / 2;
      var closestIndex = currentIndex;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slidePoint = isMobile()
          ? slide.offsetLeft
          : slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slidePoint - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateActiveSlide() {
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === currentIndex);
      });
    }

    function updateButtons() {
      if (isMobile()) {
        prevBtn.disabled = currentIndex <= 0;
        nextBtn.disabled = currentIndex >= realCount - 1;
        prevBtn.classList.toggle('is-active', currentIndex > 0);
        nextBtn.classList.toggle('is-active', currentIndex < realCount - 1);
        return;
      }

      prevBtn.disabled = false;
      nextBtn.disabled = false;
      prevBtn.classList.add('is-active');
      nextBtn.classList.add('is-active');
    }

    function getScrollLeftForIndex(index) {
      var slide = slides[index];
      if (!slide) return 0;

      if (isMobile()) {
        return slide.offsetLeft - getTrackPaddingInline();
      }

      return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
    }

    function getSlideStep() {
      if (slides.length < 2) return 0;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function getLoopDistance() {
      return getSlideStep() * realCount;
    }

    function jumpToIndex(index) {
      setSnapEnabled(false);
      currentIndex = index;
      track.scrollLeft = getScrollLeftForIndex(index);
      updateActiveSlide();
      updateButtons();
      requestAnimationFrame(function () {
        setSnapEnabled(true);
      });
    }

    function applyLoopNormalize(targetIndex) {
      if (isMobile() || realCount <= 1) return targetIndex;

      if (targetIndex === cloneFirstIndex) {
        root.classList.add('is-settling');
        track.scrollLeft = getScrollLeftForIndex(targetIndex) - getLoopDistance();
        return 1;
      }

      if (targetIndex === 0) {
        root.classList.add('is-settling');
        track.scrollLeft = getScrollLeftForIndex(targetIndex) + getLoopDistance();
        return realCount;
      }

      return targetIndex;
    }

    function clearSettling() {
      requestAnimationFrame(function () {
        root.classList.remove('is-settling');
      });
    }

    function normalizeInfiniteScroll() {
      if (isMobile() || realCount <= 1 || isNormalizing) return;

      if (currentIndex === 0 || currentIndex === cloneFirstIndex) {
        isNormalizing = true;
        setSnapEnabled(false);
        currentIndex = applyLoopNormalize(currentIndex);
        updateActiveSlide();
        updateButtons();
        clearSettling();
        requestAnimationFrame(function () {
          setSnapEnabled(true);
          isNormalizing = false;
        });
      }
    }

    function animateToIndex(index, onComplete) {
      if (index < 0 || index >= slides.length) return;

      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
        animationFrame = null;
      }

      var targetLeft = getScrollLeftForIndex(index);
      var startLeft = track.scrollLeft;
      var distance = targetLeft - startLeft;
      var visualIndex = index;

      setSnapEnabled(false);
      root.classList.remove('is-settling');

      var startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / ANIMATION_MS, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        track.scrollLeft = startLeft + distance * eased;

        currentIndex = visualIndex;
        updateActiveSlide();
        updateButtons();

        if (progress < 1) {
          animationFrame = requestAnimationFrame(step);
          return;
        }

        track.scrollLeft = targetLeft;
        currentIndex = applyLoopNormalize(index);
        updateActiveSlide();
        updateButtons();
        animationFrame = null;
        setSnapEnabled(true);
        clearSettling();

        if (onComplete) onComplete();
      }

      animationFrame = requestAnimationFrame(step);
    }

    function finishAnimatedScroll() {
      isAnimating = false;
    }

    function goToNext() {
      if (isAnimating || realCount <= 1) return;

      if (isMobile()) {
        if (currentIndex >= realCount - 1) return;
        isAnimating = true;
        animateToIndex(currentIndex + 1, finishAnimatedScroll);
        return;
      }

      if (currentIndex >= cloneFirstIndex) return;

      isAnimating = true;
      animateToIndex(currentIndex + 1, finishAnimatedScroll);
    }

    function goToPrev() {
      if (isAnimating || realCount <= 1) return;

      if (isMobile()) {
        if (currentIndex <= 0) return;
        isAnimating = true;
        animateToIndex(currentIndex - 1, finishAnimatedScroll);
        return;
      }

      if (currentIndex <= 0) return;

      isAnimating = true;
      animateToIndex(currentIndex - 1, finishAnimatedScroll);
    }

    prevBtn.addEventListener('click', goToPrev);
    nextBtn.addEventListener('click', goToNext);

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        if (isNormalizing || isAnimating) return;

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          currentIndex = getClosestIndex();
          updateActiveSlide();
          updateButtons();
          normalizeInfiniteScroll();
        }, 120);
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setupMode, 150);
    });

    if (typeof MOBILE_MQ.addEventListener === 'function') {
      MOBILE_MQ.addEventListener('change', setupMode);
    } else if (typeof MOBILE_MQ.addListener === 'function') {
      MOBILE_MQ.addListener(setupMode);
    }

    setupMode();
  }

  document.querySelectorAll('[data-mt-about-slider]').forEach(initMtAboutSlider);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-mt-about-slider]').forEach(initMtAboutSlider);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-banner"] && !Shopify.designMode) return;
  try {
    
  class MtBannerCarousel extends HTMLElement {
    connectedCallback() {
      this.media = [...this.querySelectorAll('[data-banner-media]')];
      this.content = [...this.querySelectorAll('[data-banner-content]')];
      this.textAreas = [...this.querySelectorAll('.mt-banner__content')];
      this.dots = [...this.querySelectorAll('[data-banner-dot]')];
      this.toggle = this.querySelector('[data-banner-toggle]');
      this.index = 0;
      this.request = 0;
      this.userPaused = this.dataset.autoplay !== 'true';
      this.transientPaused = false;
      this.pointerInsideText = false;
      this.focusWithin = false;
      this.interval = Number(this.dataset.interval) || 6000;
      this.transition = Number(this.dataset.transition) || 700;
      this.remaining = this.interval;
      this.onDotClick = this.onDotClick.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onViewportChange = this.onViewportChange.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onPointerCancel = this.onPointerCancel.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onPointerEnter = () => {
        this.pointerInsideText = true;
        this.syncTransientPause();
      };
      this.onPointerLeave = () => {
        this.pointerInsideText = false;
        this.syncTransientPause();
      };
      this.onFocusIn = (event) => {
        this.focusWithin = Boolean(event.target.closest('.mt-banner__content'));
        this.syncTransientPause();
      };
      this.onFocusOut = (event) => {
        this.focusWithin = Boolean(event.relatedTarget?.closest?.('.mt-banner__content'));
        this.syncTransientPause();
      };
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
      this.toggle?.addEventListener('click', this.onToggle);
      this.textAreas.forEach((textArea) => {
        textArea.addEventListener('pointerenter', this.onPointerEnter);
        textArea.addEventListener('pointerleave', this.onPointerLeave);
      });
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerCancel);
      this.addEventListener('click', this.onClick, true);
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      window.addEventListener('resize', this.onViewportChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.inView = entry.isIntersecting;
            this.syncTimer();
            this.syncVideos();
          },
          { threshold: 0.2 }
        );
        this.observer.observe(this);
      } else {
        this.inView = true;
      }

      this.updateToggle();
      this.syncTimer();
      this.syncVideos();
    }

    disconnectedCallback() {
      this.stopTimer();
      this.observer?.disconnect();
      this.dots.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      this.toggle?.removeEventListener('click', this.onToggle);
      this.textAreas.forEach((textArea) => {
        textArea.removeEventListener('pointerenter', this.onPointerEnter);
        textArea.removeEventListener('pointerleave', this.onPointerLeave);
      });
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('pointerdown', this.onPointerDown);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerCancel);
      this.removeEventListener('click', this.onClick, true);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('resize', this.onViewportChange);
    }

    async onDotClick(event) {
      const changed = await this.show(Number(event.currentTarget.dataset.bannerDot));
      if (changed) this.restartTimer();
    }

    onToggle() {
      this.userPaused = !this.userPaused;
      this.updateToggle();
      this.syncTimer();
    }

    onVisibilityChange() {
      this.syncTimer();
      this.syncVideos();
    }

    onViewportChange() {
      this.syncVideos();
    }

    onPointerDown(event) {
      if (
        this.media.length < 2 ||
        !event.isPrimary ||
        (event.pointerType === 'mouse' && event.button !== 0) ||
        event.target.closest('a, button, input, textarea, select, label')
      ) {
        return;
      }

      this.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
      };
      this.setPointerCapture(event.pointerId);
      this.syncTransientPause();
    }

    async onPointerUp(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;

      const { startX, startY } = this.drag;
      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const isSwipe = Math.abs(deltaX) >= 48 && Math.abs(deltaX) > Math.abs(deltaY);
      this.drag = null;
      this.releasePointerCapture(event.pointerId);

      if (!isSwipe) {
        this.syncTransientPause();
        return;
      }

      this.suppressClick = true;
      const nextIndex =
        deltaX < 0 ? (this.index + 1) % this.media.length : (this.index - 1 + this.media.length) % this.media.length;
      const changed = await this.show(nextIndex);
      if (changed) this.restartTimer();
      this.syncTransientPause();

      requestAnimationFrame(() => {
        this.suppressClick = false;
      });
    }

    onPointerCancel(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;
      this.drag = null;
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      this.syncTransientPause();
    }

    onClick(event) {
      if (!this.suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    onBlockSelect(event) {
      const pane = this.querySelector(`[data-block-id="${event.detail.blockId}"]`);
      if (!pane) return;
      this.userPaused = true;
      this.show(Number(pane.dataset.bannerContent));
      this.updateToggle();
      this.syncTimer();
    }

    syncTransientPause() {
      this.transientPaused = this.pointerInsideText || this.focusWithin || Boolean(this.drag);
      this.syncTimer();
    }

    async show(nextIndex) {
      if (nextIndex === this.index || !this.media[nextIndex]) return false;
      const request = ++this.request;
      const previousMedia = this.media[this.index];
      const nextMedia = this.media[nextIndex];
      const selector = window.matchMedia('(max-width: 749px)').matches
        ? '.mt-banner__image--mobile'
        : '.mt-banner__image--desktop';
      const nextImage = nextMedia.querySelector(selector);

      if (nextImage && !nextImage.complete) {
        try {
          await nextImage.decode();
        } catch {
          return false;
        }
      }
      if (request !== this.request || (nextImage && !nextImage.naturalWidth)) return false;

      previousMedia.classList.add('is-leaving');
      previousMedia.classList.remove('is-active');
      nextMedia.classList.remove('is-leaving');
      nextMedia.classList.add('is-active');

      const previousContent = this.content[this.index];
      this.content[nextIndex].classList.remove('is-leaving');
      previousContent?.classList.add('is-leaving');

      this.content.forEach((pane, index) => {
        const active = index === nextIndex;
        pane.classList.toggle('is-active', active);
        pane.setAttribute('aria-hidden', String(!active));
        if (active) pane.removeAttribute('inert');
        else pane.setAttribute('inert', '');
      });

      this.dots.forEach((dot, index) => {
        const active = index === nextIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });

      window.setTimeout(() => previousMedia.classList.remove('is-leaving'), this.transition + 40);
      window.setTimeout(() => previousContent?.classList.remove('is-leaving'), this.transition + 40);
      this.index = nextIndex;
      this.remaining = this.interval;
      this.syncVideos();
      return true;
    }

    async next() {
      await this.show((this.index + 1) % this.media.length);
      this.syncTimer();
    }

    restartTimer() {
      this.stopTimer();
      this.remaining = this.interval;
      this.syncTimer();
    }

    syncTimer() {
      const shouldRun =
        this.media.length > 1 && !this.userPaused && !this.transientPaused && this.inView !== false && !document.hidden;
      this.classList.toggle('is-timer-paused', !shouldRun);
      if (shouldRun && !this.timer) {
        this.startedAt = performance.now();
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.remaining = this.interval;
          this.next();
        }, this.remaining);
      }
      if (!shouldRun) this.stopTimer();
    }

    stopTimer() {
      if (this.timer) {
        this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
      }
      window.clearTimeout(this.timer);
      this.timer = null;
    }

    syncVideos() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const selector = isMobile ? '.mt-banner__video--mobile' : '.mt-banner__video--desktop';
      const shouldPlay = this.inView !== false && !document.hidden;

      this.media.forEach((slide, index) => {
        slide.querySelectorAll('video').forEach((video) => {
          if (index === this.index && video.matches(selector) && shouldPlay) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      });
    }

    updateToggle() {
      if (!this.toggle) return;
      this.classList.toggle('is-paused', this.userPaused);
      this.toggle.setAttribute(
        'aria-label',
        this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel
      );
    }
  }

  if (!customElements.get('mt-banner-carousel')) customElements.define('mt-banner-carousel', MtBannerCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-collection"] && !Shopify.designMode) return;
  try {
    
  class MtCollection extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-mt-filter-panel]');
      this.open = this.querySelector('[data-mt-filter-open]');
      this.close = this.querySelectorAll('[data-mt-filter-close]');
      this.open?.addEventListener('click', () => this.setFilterState(true));
      this.close.forEach((button) => button.addEventListener('click', () => this.setFilterState(false)));
      this.syncFilterSource();
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.setFilterState(false);
      });
      this.querySelectorAll('.mt-collection-filters__form input[type="checkbox"]:not([data-series-url]):not([name="mt_price_range"]), .mt-collection-filters__form input[type="radio"]:not([name="mt_price_range"])').forEach((input) =>
        input.addEventListener('change', () => input.form.submit())
      );
      const colorInputs = this.querySelectorAll('.mt-collection-filters__color-options input[type="radio"]');
      let selectedColor = Array.from(colorInputs).find((input) => input.checked);
      colorInputs.forEach((input) =>
        input.addEventListener('click', (event) => {
          if (input !== selectedColor) {
            selectedColor = input;
            return;
          }
          event.preventDefault();
          input.checked = false;
          selectedColor = undefined;
          input.form.submit();
        })
      );
      this.querySelectorAll('[data-series-url]').forEach((input) =>
        input.addEventListener('change', (event) => {
          const url = new URL(event.target.dataset.seriesUrl, window.location.origin);
          url.hash = `mt-filter-source=${encodeURIComponent(event.target.dataset.filterSource)}`;
          window.location.href = url.toString();
        })
      );
      this.querySelectorAll('a[data-filter-source]').forEach((link) =>
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const url = new URL(link.href, window.location.origin);
          url.hash = `mt-filter-source=${encodeURIComponent(link.dataset.filterSource)}`;
          window.location.href = url.toString();
        })
      );
      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-category-toggle]');
        if (!toggle) return;
        const item = toggle.closest('.mt-collection-filters__occasion-item');
        const content = item?.querySelector('.mt-collection-filters__product-types');
        if (!content) return;
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        toggle.classList.toggle('is-expanded', !isOpen);
        content.hidden = isOpen;
      });
      this.querySelectorAll('.mt-collection-filters__form input[name="mt_price_range"]').forEach((input) =>
        input.addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          const selected = event.target;
          const minParam = selected.dataset.mtPriceMinParam;
          const maxParam = selected.dataset.mtPriceMaxParam;
          url.searchParams.delete(minParam);
          url.searchParams.delete(maxParam);
          if (!selected.checked) {
            url.searchParams.delete('mt_price_range');
            window.location.href = url.toString();
            return;
          }
          if (selected.dataset.mtPriceMin) url.searchParams.set(minParam, selected.dataset.mtPriceMin);
          if (selected.dataset.mtPriceMax) url.searchParams.set(maxParam, selected.dataset.mtPriceMax);
          url.searchParams.delete('mt_price_range');
          window.location.href = url.toString();
        })
      );
      this.querySelectorAll('[data-mt-sort]').forEach((select) =>
        select.addEventListener('change', (event) => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', event.target.value);
          window.location.href = url.toString();
        })
      );
    }
    syncFilterSource() {
      const hash = window.location.hash.replace(/^#/, '');
      const source = hash.startsWith('mt-filter-source=')
        ? decodeURIComponent(hash.slice('mt-filter-source='.length))
        : '';
      this.querySelectorAll('[data-filter-source]').forEach((control) => {
        if (source === '') return;
        const isActive = control.dataset.filterSource === source;
        if (control.matches('input[type="checkbox"]')) {
          control.checked = isActive;
          control.disabled = isActive;
        } else {
          control.classList.toggle('is-active', isActive);
          if (isActive) control.setAttribute('aria-current', 'page');
          else control.removeAttribute('aria-current');
        }
      });
      if (source === '') return;
      const categorySource = source.startsWith('category:') ? source.split(':')[1] : '';
      this.querySelectorAll('[data-category-toggle]').forEach((toggle) => {
        const isExpanded = categorySource !== '' && toggle.dataset.categoryId === categorySource;
        const content = toggle.closest('.mt-collection-filters__occasion-item')?.querySelector('.mt-collection-filters__product-types');
        toggle.classList.toggle('is-expanded', isExpanded);
        toggle.setAttribute('aria-expanded', String(isExpanded));
        if (content) content.hidden = !isExpanded;
      });
    }
    setFilterState(isOpen) {
      this.panel.classList.toggle('is-open', isOpen);
      this.querySelector('.mt-collection__overlay').classList.toggle('is-open', isOpen);
      this.open?.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
      if (isOpen) this.querySelector('[data-mt-filter-close]')?.focus();
    }
  }
  if (!customElements.get('mt-collection')) customElements.define('mt-collection', MtCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-complete-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!window.MtCompleteTheLookLoader) {
    window.MtCompleteTheLookLoader = class MtCompleteTheLookLoader {
      static init(container) {
        var panel = container.querySelector('[data-mt-ctl-panel]');
        if (!panel) return;

        if (container._ctlInitBound) {
          MtCompleteTheLookLoader.load(panel, container);
          return;
        }
        container._ctlInitBound = true;

        MtCompleteTheLookLoader.load(panel, container);

        if (!document._ctlCartListener) {
          document._ctlCartListener = function (e) {
            var source = e && e.detail && e.detail.source;
            if (source !== 'cart' && source !== 'drawer') {
              var cartRoot = document.querySelector('cart-items');
              if (cartRoot && cartRoot.dataset.section) {
                fetch(window.location.pathname + '?section_id=' + cartRoot.dataset.section)
                  .then(function (r) {
                    return r.text();
                  })
                  .then(function (html) {
                    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-items');
                    if (!fresh) return;
                    cartRoot.innerHTML = fresh.innerHTML;
                    MtCompleteTheLookLoader.init(cartRoot);
                  });
                return;
              }
            }
            document.querySelectorAll('[data-mt-ctl-panel]').forEach(function (ctlPanel) {
              var host = ctlPanel.closest('cart-items, mt-complete-the-look') || document;
              MtCompleteTheLookLoader.load(ctlPanel, host);
            });
            document.querySelectorAll('mt-complete-the-look').forEach(function (sectionEl) {
              MtCompleteTheLookLoader.init(sectionEl);
            });
          };
          document.addEventListener('cart:updated', document._ctlCartListener);
        }
      }

      static shopifyRoot() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      }

      static async fetchFragment(sectionId, productId, limit, intent) {
        var root = MtCompleteTheLookLoader.shopifyRoot();
        var url =
          root +
          'recommendations/products?section_id=' +
          encodeURIComponent(sectionId) +
          '&product_id=' +
          encodeURIComponent(productId) +
          '&limit=' +
          encodeURIComponent(limit) +
          '&intent=' +
          encodeURIComponent(intent);

        var html = await fetch(url).then(function (r) {
          return r.ok ? r.text() : '';
        });
        if (!html) return '';

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('[data-complete-the-look-content]');
        if (!source || !source.querySelector('.mt-ctl__item')) return '';

        return source.innerHTML;
      }

      static async load(panel, container) {
        try {
          var root = MtCompleteTheLookLoader.shopifyRoot();
          var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });

          if (!cart.items.length) {
            if (!panel.dataset.referenceProductId) {
              if (panel.querySelector('.mt-ctl__item')) return;
              panel.hidden = true;
              if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = true;
              return;
            }
          }

          var target = panel.querySelector('[data-complete-the-look-content]');
          if (!target) return;

          if (panel.dataset.static === 'true') {
            var hasStaticItems = !!target.querySelector('.mt-ctl__item');
            panel.hidden = !hasStaticItems;
            if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = !hasStaticItems;
            return;
          }

          var showLimit = parseInt(panel.dataset.limit || '4', 10);
          var fetchLimit = Math.min(Math.max(showLimit * 3, 8), 10);
          var preferredIntent = panel.dataset.intent || 'related';
          var intents = [preferredIntent];
          if (preferredIntent !== 'related') intents.push('related');
          if (preferredIntent !== 'complementary') intents.push('complementary');

          var fragment = '';
          var referenceProductId = panel.dataset.referenceProductId;
          var preferReference = panel.dataset.preferReference === 'true';

          if (preferReference && referenceProductId) {
            for (var p = 0; p < intents.length && !fragment; p++) {
              fragment = await MtCompleteTheLookLoader.fetchFragment(
                panel.dataset.sectionId,
                referenceProductId,
                fetchLimit,
                intents[p]
              );
            }
          }

          for (var i = 0; i < cart.items.length && !fragment; i++) {
            for (var j = 0; j < intents.length && !fragment; j++) {
              fragment = await MtCompleteTheLookLoader.fetchFragment(
                panel.dataset.sectionId,
                cart.items[i].product_id,
                fetchLimit,
                intents[j]
              );
            }
          }

          if (!fragment && referenceProductId && !preferReference) {
            for (var r = 0; r < intents.length && !fragment; r++) {
              fragment = await MtCompleteTheLookLoader.fetchFragment(
                panel.dataset.sectionId,
                referenceProductId,
                fetchLimit,
                intents[r]
              );
            }
          }

          if (fragment) {
            target.innerHTML = fragment;
            var items = target.querySelectorAll('.mt-ctl__item');
            for (var k = items.length - 1; k >= showLimit; k--) {
              items[k].remove();
            }
            var hasItems = !!target.querySelector('.mt-ctl__item');
            panel.hidden = !hasItems;
            if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = !hasItems;
            if (window.MetryReveal) {
              window.MetryReveal.init();
              window.MetryReveal.initImageFade();
            }
          } else if (!target.querySelector('.mt-ctl__item')) {
            target.innerHTML = '';
            panel.hidden = true;
            if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = true;
          } else {
            panel.hidden = false;
            if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = false;
          }
        } catch (e) {
          panel.hidden = true;
          if (container.tagName === 'MT-COMPLETE-THE-LOOK') container.hidden = true;
        }
      }
    };
  }

  if (!customElements.get('mt-complete-the-look')) {
    class MtCompleteTheLookSection extends HTMLElement {
      connectedCallback() {
        MtCompleteTheLookLoader.init(this);
      }
    }

    customElements.define('mt-complete-the-look', MtCompleteTheLookSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-contact-us"] && !Shopify.designMode) return;
  try {
    
  function syncMtContactMapHeight(root) {
    const formCol = root.querySelector('.mt-contact-us__form-col');
    const map = root.querySelector('.mt-contact-us__map');
    if (!formCol || !map) return;

    const apply = () => {
      if (!window.matchMedia('(min-width: 990px)').matches) {
        map.style.height = '';
        return;
      }

      const formBottom = formCol.getBoundingClientRect().bottom;
      const mapTop = map.getBoundingClientRect().top;
      const height = Math.max(200, formBottom - mapTop);
      map.style.height = `${height}px`;
    };

    apply();
    requestAnimationFrame(apply);

    if (root.dataset.mapHeightReady === 'true') return;
    root.dataset.mapHeightReady = 'true';

    window.addEventListener('resize', apply);

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(apply);
      observer.observe(formCol);
      root.querySelectorAll('.mt-contact-us__info').forEach((item) => observer.observe(item));
    }
  }

  document.querySelectorAll('[data-mt-contact-us]').forEach(syncMtContactMapHeight);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mt-contact-us]').forEach(syncMtContactMapHeight);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-faq"] && !Shopify.designMode) return;
  try {
    
  function initMtFaq(root) {
    if (!root || root.dataset.mtFaqReady === 'true') return;
    root.dataset.mtFaqReady = 'true';

    const tabs = root.querySelectorAll('[data-mt-faq-tab]');
    const items = root.querySelectorAll('[data-mt-faq-item]');
    if (!tabs.length) return;

    const filterItems = (tabHandle) => {
      items.forEach((item) => {
        const category = item.dataset.category;
        const show = tabHandle === 'all' || category === tabHandle;
        item.hidden = !show;
        if (!show) item.open = false;
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        filterItems(tab.dataset.mtFaqTab);
      });
    });

    const activeTab = root.querySelector('[data-mt-faq-tab].is-active');
    if (activeTab) filterItems(activeTab.dataset.mtFaqTab);
  }

  document.querySelectorAll('[data-mt-faq]').forEach(initMtFaq);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mt-faq]').forEach(initMtFaq);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-favorites"] && !Shopify.designMode) return;
  try {
    
  class MtFavorites extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-favorite-item]')];
      this.grid = this.querySelector('[data-grid]');
      this.empty = this.querySelector('[data-empty]');
      this.count = this.querySelector('[data-count]');
      this.render();
      document.addEventListener('wishlist:changed', () => this.render());
      window.addEventListener('storage', (event) => {
        if (event.key === 'mt-wishlist') this.render();
      });
    }

    getWishlist() {
      try {
        const value = JSON.parse(localStorage.getItem('mt-wishlist') || '[]');
        return Array.isArray(value) ? value.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    render() {
      const wishlist = this.getWishlist();
      let visibleCount = 0;
      this.items.forEach((item) => {
        const visible = wishlist.includes(String(item.dataset.productId));
        item.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      this.count.textContent = `${visibleCount} ${this.dataset.resultsLabel}`;
      this.empty.hidden = visibleCount > 0;
      this.grid.hidden = visibleCount === 0;
    }
  }

  if (!customElements.get('mt-favorites')) customElements.define('mt-favorites', MtFavorites);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-featured-collection"] && !Shopify.designMode) return;
  try {
    
  class MtFeaturedTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"][data-panel-index]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectTab(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
    }

    selectTab(selectedTab) {
      const index = Number(selectedTab.dataset.tabIndex);
      this.tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = Number(panel.dataset.panelIndex) !== index;
      });
    }

    onKeydown(event) {
      const current = this.tabs.indexOf(event.currentTarget);
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.tabs.length - 1;
      else return;
      event.preventDefault();
      this.selectTab(this.tabs[next]);
      this.tabs[next].focus();
    }
  }

  if (!customElements.get('mt-featured-tabs')) customElements.define('mt-featured-tabs', MtFeaturedTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-featured-product-banner"] && !Shopify.designMode) return;
  try {
    
  class MtFeaturedProductBanner extends HTMLElement {
    connectedCallback() {
      this.addButton = this.querySelector('[data-add-to-cart]');
      this.status = this.querySelector('[data-status]');
      this.price = this.querySelector('.mt-featured-product-banner__price [data-price]');
      this.comparePrice = this.querySelector('.mt-featured-product-banner__price [data-compare-price]');
      this.saving = this.querySelector('.mt-featured-product-banner__price [data-saving]');
      this.eyebrow = this.querySelector('[data-eyebrow]');
      this.heading = this.querySelector('[data-heading]');
      this.description = this.querySelector('[data-description]');
      this.productOptions = [...this.querySelectorAll('[data-product-option]')];
      if (this.addButton) this.addButton.addEventListener('click', () => this.addToCart());
      this.productOptions.forEach((option) => option.addEventListener('click', () => this.selectProduct(option)));
    }

    selectProduct(selectedOption) {
      this.productOptions.forEach((option) => {
        const selected = option === selectedOption;
        option.toggleAttribute('data-selected', selected);
        option.setAttribute('aria-checked', String(selected));
      });
      this.querySelectorAll('.mt-featured-product-banner__image-wrap[data-product-handle]').forEach((media) => {
        media.classList.toggle(
          'mt-featured-product-banner__image-wrap--active',
          media.dataset.productHandle === selectedOption.dataset.productHandle
        );
      });
      this.price.textContent = selectedOption.dataset.price;
      this.comparePrice.textContent = selectedOption.dataset.comparePrice;
      this.comparePrice.hidden = !selectedOption.dataset.comparePrice;
      this.saving.textContent = selectedOption.dataset.saving;
      this.saving.hidden = !selectedOption.dataset.saving;
      if (this.eyebrow) this.eyebrow.textContent = selectedOption.dataset.eyebrow;
      if (this.heading) this.heading.textContent = selectedOption.dataset.heading;
      if (this.description) this.description.textContent = selectedOption.dataset.description;
      this.addButton.dataset.variantId = selectedOption.dataset.variantId;
      const available = selectedOption.dataset.available === 'true';
      this.addButton.disabled = !available;
      this.addButton.textContent = available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldOutLabel;
    }

    async addToCart() {
      this.addButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: this.addButton.dataset.variantId, quantity: 1 }),
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.addButton.dataset.addedText, false);
      } catch (error) {
        this.showStatus(this.addButton.dataset.errorLabel, true);
      } finally {
        this.addButton.disabled = false;
      }
    }

    showStatus(message, isError) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.classList.toggle('is-error', isError);
    }
  }

  if (!customElements.get('mt-featured-product-banner')) {
    customElements.define('mt-featured-product-banner', MtFeaturedProductBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mt-footer')) {
    customElements.define(
      'mt-footer',
      class extends HTMLElement {
        connectedCallback() {
          const select = this.querySelector('select[name="country_code"]');
          if (select) select.addEventListener('change', () => select.form.submit());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cart-count')) {
    customElements.define(
      'cart-count',
      class CartCount extends HTMLElement {
        connectedCallback() {
          this._on = () => this.refresh();
          document.addEventListener('cart:updated', this._on);
        }
        disconnectedCallback() {
          document.removeEventListener('cart:updated', this._on);
        }
        async refresh() {
          try {
            var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            var cart = await fetch(root + 'cart.js').then(function (r) {
              return r.json();
            });
            this.textContent = cart.item_count;
            this.hidden = cart.item_count === 0;
          } catch (e) {}
        }
      }
    );
  }

  class MtHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.openItem = null;
      this.openBtn = this.querySelector('[data-drawer-open]');
      this.cacheDrawerNodes();
      this.bindNavPanels();
      this.bindDrawerControls();
      this.bindMegaHover();
    }

    cacheDrawerNodes() {
      var drawerId = this.openBtn && this.openBtn.getAttribute('aria-controls');
      this.drawer = this.querySelector('[data-drawer]') || (drawerId ? document.getElementById(drawerId) : null);
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.navOverlay = this.querySelector('[data-nav-overlay]');
      this.closeBtn = this.drawer && this.drawer.querySelector('[data-drawer-close]');
    }

    bindDrawerControls() {
      if (this._drawerBound) return;

      if (!this.drawer || !this.overlay) {
        var retry = () => {
          this.cacheDrawerNodes();
          this.bindDrawerControls();
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', retry, { once: true });
        } else {
          requestAnimationFrame(retry);
        }
        return;
      }

      if (!this.openBtn) return;
      this._drawerBound = true;

      this.openBtn.addEventListener('click', () => {
        this.toggleDrawer(this.drawer.hasAttribute('hidden'));
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.toggleDrawer(false));
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.toggleDrawer(false));
      }

      if (this.navOverlay) {
        this.navOverlay.addEventListener('click', () => this.closeAllPanels());
      }

      this.drawer.addEventListener('click', (e) => {
        if (e.target.closest('a')) this.toggleDrawer(false);
      });

      if (!this._drawerKeyBound) {
        this._drawerKeyBound = true;
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeAllPanels();
            this.toggleDrawer(false);
          }
        });
      }
    }

    bindNavPanels() {
      this.querySelectorAll('[data-nav-item]').forEach((item) => {
        var trigger = item.querySelector('[data-nav-trigger]');
        var panel = item.querySelector('[data-nav-panel]');
        if (!trigger || !panel) return;

        item.addEventListener('mouseenter', () => {
          clearTimeout(this._navCloseTimer);
          this.openPanel(item, trigger, panel);
        });
        item.addEventListener('mouseleave', (e) => {
          var related = e.relatedTarget;
          if (related && (item.contains(related) || related.closest('[data-nav-item]'))) return;
          clearTimeout(this._navCloseTimer);
          this._navCloseTimer = setTimeout(() => {
            if (item.contains(document.activeElement)) return;
            this.closePanel(item, trigger, panel);
          }, 120);
        });
        item.addEventListener('focusin', () => {
          clearTimeout(this._navCloseTimer);
          this.openPanel(item, trigger, panel);
        });
        trigger.addEventListener('focus', () => this.openPanel(item, trigger, panel));
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            clearTimeout(this._navCloseTimer);
            this.closePanel(item, trigger, panel);
          }
        });
        trigger.addEventListener('click', () => {
          if (item.classList.contains('is-open')) this.closePanel(item, trigger, panel);
          else this.openPanel(item, trigger, panel);
        });
      });
    }

    bindMegaHover() {
      if (this._megaHoverBound) return;
      this._megaHoverBound = true;
      this.addEventListener('mouseover', (e) => {
        var label = e.target.closest('label.mt-header__mega-tab');
        if (!label || !this.contains(label)) return;
        var radioId = label.getAttribute('for');
        if (!radioId) return;
        var radio = document.getElementById(radioId);
        if (radio) radio.checked = true;
      });
    }

    openPanel(item, trigger, panel) {
      clearTimeout(this._navCloseTimer);
      this.querySelectorAll('[data-nav-item].is-open').forEach((openItem) => {
        if (openItem === item) return;
        var openTrigger = openItem.querySelector('[data-nav-trigger]');
        var openPanelEl = openItem.querySelector('[data-nav-panel]');
        if (!openTrigger || !openPanelEl) return;
        openItem.classList.remove('is-open');
        openTrigger.setAttribute('aria-expanded', 'false');
        openPanelEl.setAttribute('aria-hidden', 'true');
      });
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      this.openItem = item;
      this.syncNavOverlay();
    }

    closePanel(item, trigger, panel) {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
      if (this.openItem === item) this.openItem = null;
      this.syncNavOverlay();
    }

    closeAllPanels() {
      this.querySelectorAll('[data-nav-item].is-open').forEach((item) => {
        var trigger = item.querySelector('[data-nav-trigger]');
        var panel = item.querySelector('[data-nav-panel]');
        if (trigger && panel) {
          item.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
        }
      });
      this.openItem = null;
      if (this.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
      this.syncNavOverlay();
    }

    syncNavOverlay() {
      if (!this.navOverlay) return;
      if (window.matchMedia('(max-width: 989px)').matches) return;
      var hasOpenPanel = this.querySelector('[data-nav-item].is-open') !== null;
      this.navOverlay.classList.toggle('is-open', hasOpenPanel);
      this.navOverlay.setAttribute('aria-hidden', hasOpenPanel ? 'false' : 'true');
    }

    toggleDrawer(open) {
      if (!this.drawer || !this.overlay || !this.openBtn) return;
      var willOpen = open ?? this.drawer.hasAttribute('hidden');
      if (willOpen) {
        this.drawer.removeAttribute('hidden');
        this.overlay.removeAttribute('hidden');
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.drawer.classList.add('is-open');
            this.overlay.classList.add('is-open');
          });
        });
        this.openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mt-header-drawer-open');
        if (this.closeBtn) this.closeBtn.focus();
        if (window.MetryScrollLock) window.MetryScrollLock.lock();
      } else {
        this.drawer.classList.remove('is-open');
        this.overlay.classList.remove('is-open');
        this.openBtn.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mt-header-drawer-open');
        setTimeout(() => {
          if (!this.drawer.classList.contains('is-open')) {
            this.drawer.setAttribute('hidden', '');
            this.overlay.setAttribute('hidden', '');
          }
        }, 320);
        this.openBtn.focus();
        if (window.MetryScrollLock) window.MetryScrollLock.unlock();
      }
    }
  }

  if (!customElements.get('mt-header')) {
    customElements.define('mt-header', MtHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-product"] && !Shopify.designMode) return;
  try {
    
  class MtProductGallery extends HTMLElement {
    connectedCallback() {
      if (this._galleryInitialized) return;
      this._galleryInitialized = true;
      this.zoomItems = Array.from(this.querySelectorAll('[data-zoom-index]'));
      this.zoomDialog = this.querySelector('[data-zoom-dialog]');
      this.zoomImage = this.querySelector('[data-zoom-image]');
      this.zoomCount = this.querySelector('[data-zoom-count]');
      this.zoomPrev = this.querySelector('[data-zoom-prev]');
      this.zoomNext = this.querySelector('[data-zoom-next]');
      this.zoomIndex = 0;
      this.galleryTrack = this.querySelector('[data-gallery-track]');
      this.mobileSlides = Array.from(this.querySelectorAll('.mt-product__gallery-mobile .mt-product__slide[data-media-id]'));

      if (this.galleryTrack && this.mobileSlides.length > 1) {
        this.galleryTrack.addEventListener(
          'scroll',
          () => {
            if (this._ignoreGalleryScroll) return;
            if (this._galleryScrollRaf) return;
            this._galleryScrollRaf = requestAnimationFrame(() => {
              this._galleryScrollRaf = null;
              this.syncActiveFromScroll();
            });
          },
          { passive: true }
        );
      }

      this.addEventListener('click', (e) => {
        var thumb = e.target.closest('[data-target]');
        if (thumb) {
          this.showMedia(thumb.getAttribute('data-target'));
          return;
        }

        if (e.target.closest('[data-zoom-close]')) {
          this.closeZoom();
          return;
        }
        if (e.target.closest('[data-zoom-prev]')) {
          this.changeZoom(-1);
          return;
        }
        if (e.target.closest('[data-zoom-next]')) {
          this.changeZoom(1);
          return;
        }
        if (this.zoomDialog && e.target === this.zoomDialog) {
          this.closeZoom();
          return;
        }

        var zoomItem = e.target.closest('[data-zoom-index]');
        if (zoomItem) this.openZoom(parseInt(zoomItem.dataset.zoomIndex, 10), zoomItem);
      });

      this.addEventListener('keydown', (e) => {
        if (!this.zoomDialog || !this.zoomDialog.open) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.changeZoom(-1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.changeZoom(1);
        }
      });

      if (this.zoomDialog) {
        this.zoomDialog.addEventListener('close', () => {
          document.documentElement.classList.remove('mt-product-lightbox-open');
          if (this.lastZoomTrigger) this.lastZoomTrigger.focus();
        });
      }
    }

    syncActive(id) {
      if (!id) return;
      this.querySelectorAll('.mt-product__slide').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.mediaId == id);
      });
      this.querySelectorAll('.mt-product__thumb').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.target == id);
      });

      var activeThumb = this.querySelector('.mt-product__thumb.is-active');
      var thumbs = this.querySelector('.mt-product__gallery-thumbs');
      var thumbItem = activeThumb && activeThumb.closest('li');
      if (thumbs && thumbItem) {
        thumbs.scrollTo({
          left: thumbItem.offsetLeft - (thumbs.clientWidth - thumbItem.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    }

    syncActiveFromScroll() {
      if (!this.galleryTrack || !this.galleryTrack.clientWidth) return;
      var index = Math.round(this.galleryTrack.scrollLeft / this.galleryTrack.clientWidth);
      var slide = this.mobileSlides[index];
      if (slide && !slide.classList.contains('is-active')) this.syncActive(slide.dataset.mediaId);
    }

    showMedia(id) {
      if (!id) return;
      this.syncActive(id);

      var slide = this.mobileSlides.find(function (item) {
        return item.dataset.mediaId == id;
      });
      if (!slide || !this.galleryTrack || this.mobileSlides.length < 2) return;

      this._ignoreGalleryScroll = true;
      this.galleryTrack.scrollTo({
        left: slide.offsetLeft,
        behavior: window.matchMedia('(max-width: 989px)').matches ? 'smooth' : 'auto'
      });
      clearTimeout(this._ignoreGalleryScrollTimer);
      this._ignoreGalleryScrollTimer = setTimeout(() => {
        this._ignoreGalleryScroll = false;
      }, 420);
    }

    openZoom(index, trigger) {
      if (!this.zoomDialog || !this.zoomImage || !window.matchMedia('(min-width: 990px)').matches) return;
      this.zoomIndex = Number.isFinite(index) ? index : 0;
      this.lastZoomTrigger = trigger;
      this.renderZoom();
      document.documentElement.classList.add('mt-product-lightbox-open');
      if (!this.zoomDialog.open) this.zoomDialog.showModal();
    }

    closeZoom() {
      if (this.zoomDialog && this.zoomDialog.open) this.zoomDialog.close();
    }

    changeZoom(direction) {
      if (this.zoomItems.length < 2) return;
      this.zoomIndex = (this.zoomIndex + direction + this.zoomItems.length) % this.zoomItems.length;
      this.renderZoom();
    }

    renderZoom() {
      var item = this.zoomItems[this.zoomIndex];
      if (!item || !this.zoomImage) return;
      this.zoomImage.src = item.dataset.zoomSrc;
      this.zoomImage.alt = item.dataset.zoomAlt || '';
      if (this.zoomCount) this.zoomCount.textContent = (this.zoomIndex + 1) + ' / ' + this.zoomItems.length;
      var hideNavigation = this.zoomItems.length < 2;
      if (this.zoomPrev) this.zoomPrev.hidden = hideNavigation;
      if (this.zoomNext) this.zoomNext.hidden = hideNavigation;

      if (!hideNavigation) {
        var nextItem = this.zoomItems[(this.zoomIndex + 1) % this.zoomItems.length];
        if (nextItem) {
          var preloader = new Image();
          preloader.src = nextItem.dataset.zoomSrc;
        }
      }
    }
  }

  if (!customElements.get('mt-product-gallery')) {
    customElements.define('mt-product-gallery', MtProductGallery);
  }

  class MtVariantSelects extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('mt-product-form');
      this.addEventListener('change', () => {
        if (this.form) this.form.onVariantChange();
      });
    }

    get selectedValues() {
      return Array.from(this.querySelectorAll('input[type=radio]:checked')).map(function (input) {
        return input.value;
      });
    }
  }

  if (!customElements.get('mt-variant-selects')) {
    customElements.define('mt-variant-selects', MtVariantSelects);
  }

  class MtProductForm extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.idInput = this.querySelector('[data-variant-id]');
      this.selects = this.querySelector('mt-variant-selects');
      this.form = this.closest('form');
      this.status = this.querySelector('[data-atc-status]');
      this.btn = this.querySelector('[data-atc]');
      this.section = this.dataset.section;
      this.priceCurrent = document.querySelector('#price-' + this.section + ' [data-price-current]');
      this.priceCompare = document.querySelector('#price-' + this.section + ' [data-price-compare]');
      this.priceSave = document.querySelector('#price-' + this.section + ' [data-price-save]');
      this.bundleRoot = this.querySelector('[data-bundle]');
      this.bundleBtn = this.querySelector('[data-bundle-atc]');
      this.bundleItemsScript = this.querySelector('[data-bundle-items]');
      this.bundleItems = this.bundleItemsScript ? JSON.parse(this.bundleItemsScript.textContent) : [];

      this.querySelectorAll('[data-qty]').forEach(
        function (button) {
          button.addEventListener('click', () => this.stepQty(button.dataset.qty));
        }.bind(this)
      );

      this.querySelectorAll('[data-bundle-select]').forEach(
        function (input) {
          input.addEventListener('change', () => this.updateBundle());
        }.bind(this)
      );

      if (this.bundleBtn) {
        this.bundleBtn.addEventListener('click', () => this.addBundle());
        this.updateBundle();
      }
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    stepQty(dir) {
      var input = this.querySelector('.qty__input');
      var value = parseInt(input.value, 10) || 1;
      input.value = dir === 'plus' ? value + 1 : Math.max(1, value - 1);
    }

    onVariantChange() {
      if (!this.selects) return;

      var values = this.selects.selectedValues;
      var match = this.variants.find(function (variant) {
        return JSON.stringify(variant.options) === JSON.stringify(values);
      });

      this.querySelectorAll('[data-option-name]').forEach(function (label) {
        var fieldset = label.closest('fieldset');
        if (!fieldset) return;
        var checked = fieldset.querySelector('input[type=radio]:checked');
        if (!checked) return;
        var separator = label.hasAttribute('data-option-separator') ? label.dataset.optionSeparator : ': ';
        label.textContent = label.dataset.optionName + separator + checked.value;
      });

      if (!match) {
        this.setUnavailable();
        return;
      }

      this.idInput.value = match.id;

      if (match.featured_media_id) {
        var gallery = document.querySelector('mt-product-gallery');
        if (gallery) gallery.showMedia(String(match.featured_media_id));
      }

      if (this.priceCurrent) this.priceCurrent.textContent = match.price_formatted;

      if (this.priceCompare) {
        if (match.compare_at_price > match.price) {
          this.priceCompare.textContent = match.compare_at_formatted;
          this.priceCompare.hidden = false;
        } else {
          this.priceCompare.hidden = true;
        }
      }

      if (this.priceSave) {
        if (match.compare_at_price > match.price) {
          this.priceSave.textContent = this.strings.save + ' ' + (match.save_formatted || this.formatMoney(match.compare_at_price - match.price));
          this.priceSave.hidden = false;
        } else {
          this.priceSave.hidden = true;
        }
      }

      var text = this.querySelector('[data-atc-text]');
      if (match.available) {
        this.btn.disabled = false;
        text.textContent = this.strings.add;
      } else {
        this.btn.disabled = true;
        text.textContent = this.strings.soldout;
      }
    }

    formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      var currency = (this.bundleRoot && this.bundleRoot.dataset.currency) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2);
      }
    }

    getSelectedBundleItems() {
      var selectedIds = new Set(
        Array.from(this.querySelectorAll('[data-bundle-select]:checked')).map(function (input) {
          return String(input.value);
        })
      );
      return this.bundleItems.filter(function (item) {
        return selectedIds.has(String(item.id));
      });
    }

    getBundleDiscount(count) {
      if (count >= 5) return 25;
      if (count >= 3) return 15;
      return 0;
    }

    updateBundle() {
      if (!this.bundleRoot || !this.bundleBtn) return;

      var items = this.getSelectedBundleItems();
      var discount = this.getBundleDiscount(items.length);
      var total = items.reduce(function (sum, item) {
        return sum + Number(item.price || 0);
      }, 0);
      var sale = Math.round(total * (100 - discount) / 100);
      var discountLabel = this.bundleRoot.querySelector('[data-bundle-discount-label]');
      var discountText = this.bundleRoot.querySelector('[data-bundle-discount]');
      var price = this.bundleRoot.querySelector('[data-bundle-price]');
      var compare = this.bundleRoot.querySelector('[data-bundle-compare]');

      if (discountLabel) discountLabel.hidden = discount === 0;
      if (discountText) discountText.textContent = discount;
      if (price) price.textContent = this.formatMoney(sale);
      if (compare) {
        compare.textContent = this.formatMoney(total);
        compare.hidden = items.length === 0 || discount === 0;
      }
      this.bundleBtn.disabled = items.length === 0;
    }

    setUnavailable() {
      this.btn.disabled = true;
      this.querySelector('[data-atc-text]').textContent = this.strings.unavailable;
    }

    async addBundle() {
      if (!this.bundleItemsScript || !this.bundleBtn) return;

      var selectedItems = this.getSelectedBundleItems();
      var discount = this.getBundleDiscount(selectedItems.length);
      var items = selectedItems.map(function (item) {
        item.properties = item.properties || {};
        item.properties._bundle_discount_tier = discount + '%';
        return item;
      });
      if (!items.length) return;

      this.bundleBtn.disabled = true;
      this.bundleBtn.textContent = this.bundleBtn.dataset.loadingText;

      try {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');

        this.bundleBtn.textContent = this.bundleBtn.dataset.addedText;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'bundle' } }));
        this.showStatus(this.bundleBtn.dataset.addedText, false);
      } catch (err) {
        this.showStatus(err.message, true);
        this.bundleBtn.textContent = this.bundleBtn.dataset.defaultText;
      } finally {
        window.setTimeout(
          function () {
            this.bundleBtn.textContent = this.bundleBtn.dataset.defaultText;
            this.updateBundle();
          }.bind(this),
          1200
        );
      }
    }

    async onSubmit(e) {
      e.preventDefault();
      this.btn.disabled = true;

      try {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: this.idInput.value,
            quantity: parseInt(this.querySelector('.qty__input').value, 10) || 1
          })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');

        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'product' } }));
        this.showStatus(this.strings.added, false);
      } catch (err) {
        this.showStatus(err.message, true);
      } finally {
        this.btn.disabled = false;
      }
    }

    showStatus(message, isError) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.hidden = false;
      this.status.classList.toggle('is-error', !!isError);
    }
  }

  if (!customElements.get('mt-product-form')) {
    customElements.define('mt-product-form', MtProductForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-search-header"] && !Shopify.designMode) return;
  try {
    
  class MtSearchHeader extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.mt-search-header__form');
      this.typeInput = this.form?.querySelector('[name="type"]');
      if (!this.form || !this.typeInput) return;

      this.syncTypes();
      this.form.addEventListener('submit', () => this.syncTypes());

      const url = new URL(window.location.href);
      const query = url.searchParams.get('q');
      if (query && this.typeInput.value && url.searchParams.get('type') !== this.typeInput.value) {
        url.searchParams.set('type', this.typeInput.value);
        window.location.replace(url.toString());
      }
    }
    syncTypes() {
      const types = [];
      if (document.querySelector('.mt-search-products')) types.push('product');
      if (document.querySelector('.mt-search-posts')) types.push('article');
      this.typeInput.value = types.join(',');
    }
  }
  if (!customElements.get('mt-search-header')) customElements.define('mt-search-header', MtSearchHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-testimonials"] && !Shopify.designMode) return;
  try {
    
  class MtTestimonialsTicker extends HTMLElement {
    connectedCallback() {
      this.rows = [...this.querySelectorAll('[data-row]')];
      this.paused = false;
      this.handleVisibility = this.handleVisibility.bind(this);
      this.observer = new IntersectionObserver(this.handleVisibility, { threshold: 0.05 });
      this.observer.observe(this);
      this.addEventListener('mouseenter', () => this.setPaused(true));
      this.addEventListener('mouseleave', () => this.setPaused(false));
      this.addEventListener('focusin', () => this.setPaused(true));
      this.addEventListener('focusout', () => this.setPaused(false));
    }

    handleVisibility(entries) {
      this.setPaused(!entries[0].isIntersecting);
    }

    setPaused(paused) {
      this.paused = paused;
      this.classList.toggle('is-paused', paused);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('mt-testimonials-ticker')) {
    customElements.define('mt-testimonials-ticker', MtTestimonialsTicker);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dialog = document.querySelector('[data-mt-welcome]');
    if (!dialog || dialog.dataset.bound === 'true') return;
    dialog.dataset.bound = 'true';

    var storageKey = dialog.dataset.storageKey || 'mt-welcome-popup';
    var frequency = dialog.dataset.frequency || 'once';
    var delay = parseInt(dialog.dataset.delay || '800', 10);
    var isEditor = window.Shopify && Shopify.designMode;

    function hasSeen() {
      if (frequency === 'always') return false;
      if (frequency === 'session') return window.sessionStorage.getItem(storageKey) === '1';
      return window.localStorage.getItem(storageKey) === '1';
    }

    function markSeen() {
      if (frequency === 'always') return;
      if (frequency === 'session') {
        window.sessionStorage.setItem(storageKey, '1');
        return;
      }
      window.localStorage.setItem(storageKey, '1');
    }

    function openPopup() {
      if (!dialog.open) dialog.showModal();
    }

    function closePopup() {
      if (dialog.open) dialog.close();
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog || event.target.closest('[data-mt-welcome-close]')) {
        markSeen();
        closePopup();
      }
    });

    dialog.querySelectorAll('[data-mt-welcome-cta]').forEach(function (link) {
      link.addEventListener('click', function () {
        markSeen();
      });
    });

    var form = dialog.querySelector('.mt-welcome__form');
    if (form) {
      var fields = form.querySelector('[data-mt-welcome-fields]');
      var success = form.querySelector('[data-mt-welcome-success]');
      var error = form.querySelector('[data-mt-welcome-error]');
      var submit = form.querySelector('[data-mt-welcome-submit]');
      var defaultSubmit = submit ? submit.textContent : '';

      function showSuccess() {
        markSeen();
        if (fields) fields.hidden = true;
        if (success) success.hidden = false;
        if (error) error.hidden = true;
      }

      function showError(message) {
        if (!error) return;
        error.textContent = message || 'Please enter a valid email.';
        error.hidden = false;
      }

      if (form.dataset.posted === 'true') showSuccess();

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Sending…';
        }
        if (error) error.hidden = true;

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/javascript' }
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Request failed');
            showSuccess();
          })
          .catch(function () {
            showError('Unable to subscribe right now. Please try again.');
          })
          .finally(function () {
            if (submit) {
              submit.disabled = false;
              submit.textContent = defaultSubmit;
            }
          });
      });
    }

    dialog.addEventListener('cancel', function () {
      markSeen();
    });

    if (isEditor) {
      openPopup();
      document.addEventListener('shopify:section:select', function (event) {
        if (event.target && event.target.contains(dialog)) openPopup();
      });
      return;
    }

    if (hasSeen()) return;
    window.setTimeout(openPopup, Math.max(0, delay));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class BgVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { this.load(); this.observer.disconnect(); }
        });
      }, { rootMargin: '200px' });
      this.observer.observe(this);
    }
    load() {
      const src = this.video.getAttribute('data-src');
      if (src && !this.video.src) {
        var host = this;
        var revealed = false;
        var reveal = function () {
          if (!revealed) { revealed = true; host.classList.add('is-playing'); }
        };
        if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
          this.video.requestVideoFrameCallback(reveal);
        } else {
          this.video.addEventListener('playing', function () { setTimeout(reveal, 500); }, { once: true });
        }
        this.video.src = src;
        this.video.play().catch(function () {});
      }
    }
  }
  if (!customElements.get('bg-video')) customElements.define('bg-video', BgVideo);

  } catch(e) { console.error(e); }
})();
})();
